import { superToggle } from "./helpers/super-toggle";
import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', event => {
    let openContactFormButtons = document.querySelectorAll('a[href*="#open-contact-form"]');
    let contactFormModal = document.getElementById('contact-form-modal');
    let contactFormCross = document.getElementById('contact-form-modal-cross');
    let contactFormBackdrop = document.getElementById('contact-form-modal-backdrop');

    let clearedStyles = false;

    if (contactFormModal) {
        for (let button of openContactFormButtons) {
            button.addEventListener('click', event => {
                event.preventDefault();
                if (!clearedStyles) {
                    contactFormModal.removeAttribute('style');
                    clearedStyles = true;
                    const waitForClearedStyles = setTimeout(() => {
                        toggleModalVisibility();
                    }, 50);
                } else {
                    toggleModalVisibility();
                }
            });
        }

        if (contactFormCross) {
            contactFormCross.addEventListener('click', () => {
                toggleModalVisibility();
            });
        }

        if (contactFormBackdrop) {
            contactFormBackdrop.addEventListener('click', () => {
                toggleModalVisibility();
            });
        }

        const toggleModalVisibility = () => {
            superToggle(contactFormModal, ['opacity-0', 'pointer-events-none', 'select-none']);
            if (contactFormCross) {
                superToggle(contactFormCross, ['pointer-events-auto', 'cursor-pointer']);
            }
            bodyLockToggle();
        };
    }
});
